
import React from 'react';
import { withTheme } from 'styled-components';
import assetsImage from 'assets/Ui/assets.png';
import assetsImageDark from 'assets/Ui/assets_dark.png';
import foramtImageDark from 'assets/Ui/foramt_section_dark.png';
import foramtImage from 'assets/Ui/foramt_section.png';
import materialImageDark from 'assets/Ui/material_section_dark.png';
import materialImage from 'assets/Ui/material_section.png';
import speedIcon from 'assets/Ui/speedIcon.png';
import consIcon from 'assets/Ui/consIcon.png';
import flexIcon from 'assets/Ui/flexIcon.png';
import { useSelector } from 'react-redux';
import constants from 'constants/index';

import {
  Section,
  Wrapper,
  Title,
  Subtitle,
  Features,
  Feature,
  FeatureTitle,
  FeatureText,
  AssetsSection,
  AssetsImage,
  AssetsContent,
  AssetsText,
  FormatGrid,
  ListTitle,
  GridList,
  ListItem,
  MaterialSection,
  MaterialText,
  MaterialTitle,
  MaterialImage,
  PublishingSection,
  PublishingText,
  PublishingTitle,
  PublishingDesc,
  PublishingImage,
  PublishingColumns,
  PublishingList,
  FeatureIcon,
  SectionTitle,
} from './whyFoveaStyles';

const light = constants.THEME.LIGHT;


const WhyFovea = withTheme(props => {
  const { theme } = props;
  const userDataStore = useSelector(state => state.userData);
  const selectedTheme = userDataStore.userPreferences.theme;
  return (
    <Wrapper>
      <div>
        <Section>
          <Title >Why FOVEA?</Title>
          <Subtitle>
            Subscribe, Create, and increase consistency among all of your projects!
          </Subtitle>
          <Features>
            <Feature>
              <FeatureTitle>
                <FeatureIcon src={speedIcon} alt="" />
                Speed &amp; Simplicity:
              </FeatureTitle>
              <FeatureText>
                Quickly convert and customize models without the need for extra software.
              </FeatureText>
            </Feature>
            <Feature>
              <FeatureTitle>
                <FeatureIcon src={flexIcon} alt="" />
                Flexibility:
              </FeatureTitle>
              <FeatureText>
                Export in a wide range of formats to suit any design or rendering environment.
              </FeatureText>
            </Feature>
            <Feature>
              <FeatureTitle>
                <FeatureIcon src={consIcon} alt="" />
                Consistency:
              </FeatureTitle>
              <FeatureText>
                RPCs ensure your models perform predictably across multiple applications.
              </FeatureText>
            </Feature>
          </Features>
        </Section>
        <SectionTitle theme={theme} $selectedTheme={selectedTheme}>
          Create 3D models for your workflow.
        </SectionTitle>
        <AssetsSection>
          <AssetsImage src={selectedTheme === light ? assetsImage : assetsImageDark} alt="3D model grid" />
          <AssetsContent>
            <MaterialTitle theme={theme} $selectedTheme={selectedTheme} >Bring Your Own Assets</MaterialTitle>
            <AssetsText $selectedTheme={selectedTheme}>
              Turn everyday 3D models into dynamic, reusable assets that streamline your entire workflow.
            </AssetsText>
            <FormatGrid>
              <div>
                <ListTitle $selectedTheme={selectedTheme}>Supported Import Formats:</ListTitle>
                <GridList>
                  <ul>
                    <li><ListItem $selectedTheme={selectedTheme}>RPC</ListItem></li>
                    <li><ListItem $selectedTheme={selectedTheme}>GLTF / GLB</ListItem></li>
                    <li><ListItem $selectedTheme={selectedTheme}>FBX</ListItem></li>
                  </ul>
                  <ul>
                    <li><ListItem $selectedTheme={selectedTheme}>OBJ</ListItem></li>
                    <li><ListItem $selectedTheme={selectedTheme}>USD / USDZ</ListItem></li>
                    <li><ListItem $selectedTheme={selectedTheme}>PNG</ListItem></li>
                  </ul>
                </GridList>
              </div>
              <div>
                <ListTitle $selectedTheme={selectedTheme}>Application Exporters:</ListTitle>
                <GridList>
                  <ul>
                    <li><ListItem $selectedTheme={selectedTheme}>Blender</ListItem></li>
                    <li><ListItem $selectedTheme={selectedTheme}>SketchUp</ListItem></li>
                    <li><ListItem $selectedTheme={selectedTheme}>3ds Max</ListItem></li>
                  </ul>
                  <ul>
                    <li><ListItem $selectedTheme={selectedTheme}>Revit</ListItem></li>
                    <li><ListItem $selectedTheme={selectedTheme}>Rhino</ListItem></li>
                  </ul>
                </GridList>
              </div>
            </FormatGrid>
          </AssetsContent>
        </AssetsSection>
      </div>
      <MaterialSection>
        <MaterialText>
          <MaterialTitle theme={theme} $selectedTheme={selectedTheme}>
            Material Customization Options
          </MaterialTitle>
          <AssetsText $selectedTheme={selectedTheme}>
            Make quick edits and adjustments to materials so you can focus on design without getting bogged down.
          </AssetsText>
        </MaterialText>
        <MaterialImage src={selectedTheme === light ? materialImage : materialImageDark} />
      </MaterialSection>

      <PublishingSection>
        <PublishingText>
          <PublishingTitle theme={theme} $selectedTheme={selectedTheme}>
            Simple Publishing
          </PublishingTitle>
          <PublishingDesc $selectedTheme={selectedTheme}>
            Let FOVEA do the heavy lifting to diversify
            your models so you spend less time switching between software and more time creating.
          </PublishingDesc>
          <ListTitle $selectedTheme={selectedTheme}>Supported Output Formats:</ListTitle>
          <PublishingColumns>
            <div>
              <PublishingList $selectedTheme={selectedTheme}>
                <li><ListItem $selectedTheme={selectedTheme}> RPC </ListItem></li>
                <li><ListItem $selectedTheme={selectedTheme}> Enscape Asset / Package </ListItem></li>
                <li><ListItem $selectedTheme={selectedTheme}>Chaos Vrscene</ListItem></li>
                <li><ListItem $selectedTheme={selectedTheme}>D5A - D5Render</ListItem></li>
                <li><ListItem $selectedTheme={selectedTheme}>Lumion (WIP)</ListItem></li>
                <li><ListItem $selectedTheme={selectedTheme}>Twinmotion (WIP)</ListItem></li>
              </PublishingList>
            </div>
            <div>
              <PublishingList $selectedTheme={selectedTheme}>
                <li><ListItem $selectedTheme={selectedTheme}>Datasmith</ListItem></li>
                <li><ListItem $selectedTheme={selectedTheme}>GLTF / GLB / GLTF Archive</ListItem></li>
                <li><ListItem $selectedTheme={selectedTheme}>USD / USDZ</ListItem></li>
                <li><ListItem $selectedTheme={selectedTheme}>DAE (Collada)</ListItem></li>
                <li><ListItem $selectedTheme={selectedTheme}>OBJ / FBX</ListItem></li>
                <li><ListItem $selectedTheme={selectedTheme}>BLEND</ListItem></li>
              </PublishingList>
            </div>
          </PublishingColumns>
        </PublishingText>
        <PublishingImage src={selectedTheme === light ? foramtImage : foramtImageDark} alt="Publishing options UI" />
      </PublishingSection>
      <SectionTitle theme={theme} $selectedTheme={selectedTheme}>
       Shop the FOVEA Marketplace.
      </SectionTitle>
    </Wrapper>
  );
});

export default WhyFovea;
